<div class="position-reletivediv popup-inner-space">
    <div class="text-right flow-right">
        <img src="assets/images/close.svg" alt="..." class="img-fluid closeicon2 cursor-pointer" (click)="Close()">
    </div>
</div>
<form class="width100 " [formGroup]="RegisterControlValForm">
    <div class="container-data56 popup-inner-space">
        <div class="errmsg error-fix" *ngIf="errorMsg">{{errorMsg}}</div>
        <div class="sucessmsg  error-fix" *ngIf="successMsg">{{successMsg}}</div>
    </div>
    <div class="row margin-0">
        <div class="col-lg-6 mt-1 paddingleftright5">
            <div class="fxg-field fxg-field2">
                <mat-form-field style="display:block;" title="Register Name">
                    <mat-select formControlName="RegisterDataId">
                        <mat-option value="">(Select RegisterName)</mat-option>
                        <mat-option MatFormFieldControl="RegisterDataId" *ngFor="let lstregister of RegisterData"
                            value="{{lstregister.RegisterDataId}}">
                            {{lstregister.RegisterName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <span class="error_msg" *ngIf="displayMessage.RegisterDataId">{{displayMessage.RegisterDataId}}</span>
            </div>
        </div>
        <div class="col-lg-6 mt-1 padding-right-5" *ngIf="widgetType == 'TextBox' || widgetType == 'UpdateTextBox'">
            <div class="fxg-field fxg-field2">
                <input formControlName="RegisterValue" id="RegisterValue"
                    class="fxg-field__input-text fxg-field__input--required sessioncamexclude">
                <span class="fxg-field__placeholder fxg-field__floating-placeholder" tabindex="-1">Register Value</span>
                <div class="main-errormsg" *ngIf="displayMessage.RegisterValue">
                    {{displayMessage.RegisterValue}}
                </div>
            </div>
        </div>
        <div class="col-lg-6 mt-1 padding-right-5 cursor-pointer top-12" *ngIf="widgetType == 'Toggle' || widgetType == 'UpdateToggle'" (click)="ControlClick()">
            <mat-slide-toggle formControlName="RegisterValue1"></mat-slide-toggle>
        </div>
    </div>
</form>
<div class="margin-top-20  button-fix-bottom save-cancel float-right-btn margin-top73">
    <button class="btncommon width-fix67" [ngClass]="{'margin-right-5' : !isdisplaySend}" id="btngsmconfigSave" (click)="SaveUserControlScreenData()">Save</button>
    <button class="btn-orange btncommon btn-orange-SendToMail12 width-fix67" *ngIf="isdisplaySend" id="btngsmconfigSend" (click)="SendDatabyMQTT()">Send</button>
</div>